import React, { PureComponent } from 'react'
import { arrayOf, number, string, shape } from 'prop-types'
import { Text } from 'components'
import { min, max } from 'lodash'

export class PanelBarChart extends PureComponent {
    static propTypes = {
        title: string.isRequired,
        values: arrayOf(shape({
            label: string.isRequired,
            value: number.isRequired
        })).isRequired,
        className: string
    }

    state = {
        initial: true
    }

    componentWillMount() {
        this.refreshValues(this.props)
    }
    componentDidMount() {
        setTimeout(() => this.setState({ initial: false }), 100)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.values !== this.props.values) {
            this.refreshValues(nextProps)
        }
    }

    refreshValues = props => {
        const { values } = props
        const minValue = min(values.map(x => x.value))
        const maxValue = max(values.map(x => x.value))
        // dynamicRange is only for exaggerate the difference between the min and max values if they are too near from each other
        const dynamicRangeRatio = ((maxValue - minValue) / maxValue) * 100
        const scaledDynamicRange = dynamicRangeRatio < 20 ? dynamicRangeRatio * 2 : dynamicRangeRatio
        const minScaledValue = 100 - scaledDynamicRange
        this.values = values.map(({ label, value }) => ({
            label,
            value,
            scaledValue: (((value - minValue) / (maxValue - minValue)) * scaledDynamicRange) + minScaledValue
        }))
    }

    renderBar({ label, value, scaledValue }, index) {
        const topValue = 100 - Math.max(Math.min(scaledValue, 100), 2)
        const clipPathId = `clip-path-${Math.round(Math.random() * 10000)}`
        return (
            <div key={index} className="Panel-Chart-Bar-Wrapper">
                <Text className="Panel-Chart-Bar-Value" style={{ top: `${topValue}%` }}>{Math.round(value)}</Text>
                <svg className="Panel-Chart-Bar" viewBox="0 0 100 100" preserveAspectRatio="none">
                    <defs>
                        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-bar">
                            <stop stopColor="#A4EBD9" offset="0%" />
                            <stop stopColor="#A4EBD9" offset="35%" />
                            <stop stopColor="#B3395C" offset="100%" />
                        </linearGradient>
                        <clipPath id={clipPathId}>
                            <rect x="0" y={topValue} width="100" height={100 - topValue} />
                        </clipPath>
                    </defs>
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <rect fill="url(#linearGradient-bar)" clipPath={`url(#${clipPathId})`} x="0" y="0" width="100" height="100" />
                    </g>
                </svg>
                <Text className="Panel-Chart-Bar-Label">{label}</Text>
            </div>
        )
    }
    render() {
        const { title, values, className, ...otherProps } = this.props
        const { initial } = this.state
        return (
            <div className={['Panel-Chart Performance flex col-stretch-center h-100', className, { Initial: initial }]} {...otherProps}>
                <Text className="Panel-Chart-Title">{title}</Text>
                <div className="flex-grow flex row-stretch">
                    {this.values.map(this.renderBar)}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Panel/PanelBarChart.js